import React from "react";
import classes from "./couponDetailPage.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCouponByIdQuery } from "../../../services/coupon/couponApiSlice";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { StatusPill } from "../../order/orderTable/orderTableColumnsConfig";
import { toast } from "react-toastify";
import { CouponDetailForm } from "../../../component/coupon/couponDetail/CouponDetailForm";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";
import {
  useDeleteCouponMutation,
  useUpdateCouponMutation,
} from "../../../services/coupon/couponMutationApiSlice";

const statusconfig = {
  0: {
    label: "INACTIVE",
    bg: "#FDECEA",
    color: "#D92D20",
    Icon: XCircleIcon,
  },
  1: {
    label: "ACTIVE",
    bg: "#E6F7EF",
    color: "#00A167",
    Icon: CheckCircleIcon,
  },
};

export const CouponDetailPage = () => {
  const { couponId } = useParams();
  const navigate = useNavigate();

  const { data: couponDetail, isSuccess } = useGetCouponByIdQuery(couponId);

  const [updateCoupon, { isLoading: isUpdating }] = useUpdateCouponMutation();
  const [deleteCoupon, { isLoading: isDeleting }] = useDeleteCouponMutation();

  const couponStatusKey = couponDetail?.is_active ?? "";
  const couponStatusConfig = statusconfig[couponStatusKey];

  const handleUpdate = async (values) => {
    try {
      const response = await updateCoupon({ id: couponId, ...values }).unwrap();

      toast.success(
        response?.message?.displayMessage || "Blog Updated Successfully"
      );
      navigate("/coupons");
    } catch (err) {
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to update blog"
      );
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteCoupon(couponId).unwrap();
      toast.success(
        response?.message?.displayMessage || "Blog Deleted Successfully"
      );
      navigate("/coupons"); // redirect to blog list after delete
    } catch (err) {
      console.error("Delete failed", err);
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to delete blog"
      );
    }
  };
  return isSuccess ? (
    <div className={classes.wrapper}>
      <div className={classes.page}>
        <h2 className={classes.pageTitle}>{`Coupon ID: ${couponDetail.id}`}</h2>
        <div className={classes.page__payment}>
          <h2 className={classes.page__payment__title}>Status: </h2>
          {couponStatusConfig && <StatusPill {...couponStatusConfig} />}
        </div>
      </div>

      <CouponDetailForm
        initialValues={couponDetail}
        onSubmit={handleUpdate}
        onDelete={handleDelete}
        isSubmitting={isUpdating}
        isDeleting={isDeleting}
      />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
